<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import ChannelIcon from 'dashboard/components-next/icon/ChannelIcon.vue';

// Multi-sucursal · 2026-05-18 (Victor): debajo del nombre del cliente, en vez
// del nombre de la bandeja ("WhatsApp Victor Guzmán"), mostramos la sucursal
// de origen con un punto de color · ej. "● Sucursal SDO · 8297690461".
// Si el inbox no tiene sucursal (legacy), se mantiene el nombre de la bandeja.
const props = defineProps({
  inbox: {
    type: Object,
    default: () => ({}),
  },
});

const store = useStore();

const branch = computed(() => {
  const id = props.inbox?.branch_id;
  if (!id) return null;
  return store.getters['branches/getBranches'].find(b => b.id === id) || null;
});

// Color estable por sucursal · SDO azul, SDE verde (pedido Victor); el resto
// usa una paleta determinística por id para que cada sucursal tenga siempre
// el mismo color (al sumar Santiago/Romana cada una sale distinta).
const PALETTE = [
  'bg-emerald-500',
  'bg-blue-500',
  'bg-purple-500',
  'bg-amber-500',
  'bg-rose-500',
  'bg-cyan-500',
];
const CODE_COLORS = { SDO: 'bg-blue-500', SDE: 'bg-emerald-500' };

const branchDotColor = computed(() => {
  const b = branch.value;
  if (!b) return 'bg-n-slate-9';
  return (
    CODE_COLORS[(b.code || '').toUpperCase()] || PALETTE[b.id % PALETTE.length]
  );
});

const phone = computed(() => {
  const raw = props.inbox?.phone_number;
  if (raw) return String(raw).replace(/^\+/, '');
  // WAHA/Channel::Api a veces no expone phone_number → sacar dígitos del nombre.
  const digits = (props.inbox?.name || '').replace(/\D/g, '');
  return digits.length >= 7 ? digits : '';
});

const branchTitle = computed(() => {
  const b = branch.value;
  if (!b) return props.inbox?.name || '';
  const base = `Sucursal ${b.code || b.name}`;
  return phone.value ? `${base} · ${phone.value}` : base;
});
</script>

<template>
  <div :title="branchTitle" class="flex items-center gap-1 min-w-0">
    <template v-if="branch">
      <span
        class="flex-shrink-0 w-2 h-2 rounded-full"
        :class="branchDotColor"
      />
      <span class="truncate text-label-small text-n-slate-11">
        <span class="font-medium text-n-slate-12">
          Sucursal {{ branch.code || branch.name }}
        </span>
        <template v-if="phone"> · {{ phone }}</template>
      </span>
    </template>
    <template v-else>
      <ChannelIcon :inbox="inbox" class="size-4 flex-shrink-0 text-n-slate-11" />
      <span class="truncate text-label-small text-n-slate-11">
        {{ inbox.name }}
      </span>
    </template>
  </div>
</template>
